import { useContext, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import usePageTitle from "../hooks/usePageTitle";

import { ToastContext } from "../Components/ToastProvider";

import Typography from "@mui/material/Typography";
import LoadingButton from "../Components/LoadingButton";

import "../App.css";

const names1 = [
  "Super",
  "Big",
  // 'Cool',
  // 'Nice'
];

const names2 = [
  "Foodie",
  "Gourmet",
  // 'Cat',
  // 'Voyager'
];

const names = [];

names1.forEach((name1) => {
  names2.forEach((name2) => {
    const name = name1 + name2 + Math.round(Math.random() * 1000);
    names.push(name.toLowerCase());
  });
});

function Register(id) {
  const { createToast, dismissToast } = useContext(ToastContext);

  const { register, errors } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [email, setEmail] = useState("");
  const [newsletterSubscribed, setNewsletterSubscribed] = useState(true);

  const [disabled, setDisabled] = useState(false);

  const handleSuggestionChoice = (event) => {
    setUsername(event.target.innerHTML);
  };
  const handleSubmit = (event) => {
    setDisabled(true);
    event.preventDefault();
    dismissToast(id);

    if (password !== passwordConfirm) {
      createToast("The two passwords don't match.", "error");
      return;
    }
    register(
      email,
      password,
      passwordConfirm,
      username,
      newsletterSubscribed
    ).then(async (success) => {
      if (success) {
        createToast(
          "Success!  Please check your inbox for a link to confirm your email.",
          "success",
          true
        );
        navigate(state?.path || "/");
        setDisabled(false);
      } else {
        createToast("Please try again.", "error");
        setDisabled(false);
      }
    });
  };

  usePageTitle(`Register | Fudopia | Meet. Eat. Repeat.`);

  return (
    <>
      <Typography variant="h1" component="div">
        Register
      </Typography>
      <p
        className="remark centered"
        style={{ textAlign: "center", marginTop: "20px" }}
      >
        🔓 First 200 users get a whole year free. Don’t miss your spot!
      </p>
      {Object.keys(errors).map((key, i) => (
        <div key={i}>
          {errors[key]?.map((errorMessage, i) => (
            <div key={key}>
              {key === "email" && (
                <div>
                  <p className="error-message max-w-500">
                    Please enter a different email. If this email is yours and
                    you have already registered, please confirm your email
                    address by clicking the link in the message we sent to your
                    email.
                  </p>
                  <p className="underline">
                    <Link to="/resend-email-confirm">
                      Resend Email Confirm Link
                    </Link>
                  </p>
                </div>
              )}
              {key === "username" && (
                <div>
                  <p className="error-message max-w-500">
                    Please choose a different username
                  </p>
                  <p className="error-message">{errorMessage}</p>
                </div>
              )}
              {key === "non_field_errors" && (
                <div>
                  <p className="error-message max-w-500">{errorMessage}</p>
                </div>
              )}              
            </div>
          ))}
        </div>
      ))}
      <form onSubmit={handleSubmit} id="register-form">
        <label htmlFor="username">Your Username</label>
        <p className="remark">The way you show up on Fudopia</p>
        <input
          id="username"
          type="text"
          required
          pattern="[a-z0-9]{3,13}"
          autocapitalize="off"
          autocorrect="off"
          inputmode="latin"
          value={username}
          onChange={(event) => {
            setUsername(event.target.value);
          }}
        ></input>
        <p className="remark">
          Keep it simple: 3–13 characters, lowercase letters and numbers only.
          No fancy stuff like spaces or symbols
        </p>
        <p className="remark">Few suggestions:</p>
        <ul onClick={handleSuggestionChoice} className="suggestions">
          {names.map((name, i) => (
            <li key={i}>{name}</li>
          ))}
        </ul>
        <label htmlFor="email">Your Email</label>
        <input
          id="email"
          type="email"
          required
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        ></input>
        <label htmlFor="password">Your Password</label>
        <p className="remark">
          Must contain at least one number and one uppercase and lowercase
          letter, and at least 8 or more characters
        </p>
        <input
          id="password"
          type="password"
          required
          value={password}
          minLength="8"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          onChange={(event) => {
            setPassword(event.target.value);
          }}
        ></input>
        <label htmlFor="password2">Confirm Password</label>
        <input
          id="password2"
          type="password"
          required
          value={passwordConfirm}
          minLength="8"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          onChange={(event) => {
            setPasswordConfirm(event.target.value);
          }}
        ></input>
        <div>
          <input
            style={{ float: "left", margin: "6px 7px 0 0" }}
            id="newsletter"
            type="checkbox"
            checked={newsletterSubscribed}
            onChange={(event) => {
              setNewsletterSubscribed(event.target.checked);
            }}
          />
          <label style={{ margin: 0 }} htmlFor="newsletter">
            Newsletter
          </label>
          <div style={{ textAlign: "left", marginBottom: "20px" }}>
            We send a short weekly email with fun new events and Fudopia
            features. You can unsubscribe anytime.
          </div>
        </div>
        <LoadingButton
          type="submit"
          color="primary"
          variant="contained"
          disabled={disabled}
        >
          Register
        </LoadingButton>
        <p className="terms">
          By signing up, you confirm that you're at least 20 years old and agree
          to our{" "}
          <Link target="_blank" to="/terms-conditions">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link target="_blank" to="/privacy-policy">
            Privacy Policy
          </Link>
          .
        </p>
        <p className="margin-t-40">
          Already a member?
          <Link to="/login" className="underline">
            {" "}
            Login
          </Link>
        </p>
      </form>
    </>
  );
}

export default Register;
